<template>
  <div class="indicator">
    <template v-for="(step, idx) in steps">
      <StepIcon
          :class="{active: (activeStepIndex === idx)}"
          :index="idx"
          :index-number="idx"
          :step="step"
          @go-to-step="goToStep"
      />
      <i class="spacer" v-if="idx !== steps.length -1"></i>
    </template>
  </div>
</template>

<script>
import StepIcon from './StepIcon.vue';

export default {
  components: {
    StepIcon,
  },
  name: "FormIndicator.vue",
  emits: ['go-to-step'],
  props: {
    defaultActiveStepId: String,
    activeStepIndex: Number,
    steps: {
      validator(value) {
        if (value instanceof HTMLCollection) return true;
        return false;
      }
    },
  },
  mounted() {
    this.selectDefaultActiveStep();
  },
  methods: {
    selectDefaultActiveStep() {
      if (this.defaultActiveStepId !== undefined && this.defaultActiveStepId !== null) {
        document.getElementById(this.defaultActiveStepId)?.click();
      }
    },
    goToStep(stepIndex) {
      this.$emit('go-to-step', stepIndex);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: $spacing-lg;
  .spacer {
    width: $spacing-xxl;
    border-radius: 9999px;
    background-color: $brand-primary;
    height: 2px;
  }
}
</style>
